import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { dashboard: () => import('./DashboardPage.vue') },
} satisfies FeatureRoutes
